import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import APIs from "../../APIs";

const Mypayment = () => {
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const user_id = userData?.user_id;
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const res = await APIs.post(
          "booking/getTransactions",
          { user_id },
          { headers: { "Content-Type": "application/json" } }
        );
        if (res.data.data) {
          setTransactions(res.data.data);
        } else {
          setTransactions([]);
        }
      } catch (error) {
        console.error("Error fetching payment history:", error);
      } finally {
        setLoading(false);
      }
    };
    if (user_id) fetchPayments();
  }, [user_id]);

  // Pagination logic
  const totalPages = Math.ceil(transactions.length / rowsPerPage);
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentTransactions = transactions.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // Create pagination numbers with ellipsis
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <>
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* Sidebar */}
              <div className="col-lg-3">
                <Sidebar />
              </div>

              {/* Main Content */}
              <div className="col-lg-9">
                <h5 className="card-title mb-3">Payment History</h5>

                <div className="card mt-30">
                  <div className="card-body p-0">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="table-responsive">
                          {loading ? (
                            <p className="text-center my-4">Loading...</p>
                          ) : transactions.length > 0 ? (
                            <>
                              <table className="table mb-0">
                                <thead className="table-success">
                                  <tr>
                                    <th>Date</th>
                                    <th>Transaction ID</th>
                                    <th>Amount</th>
                                    <th>Payment Mode</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {currentTransactions.map((txn, idx) => (
                                    <tr key={idx}>
                                      <td>
                                        {new Date(
                                          txn.payment_date
                                        ).toLocaleDateString("en-GB")}
                                      </td>
                                      <td>#{txn.payment_transaction_id || "-"}</td>
                                      <td>$ {txn.amount || 0}</td>
                                      <td>{txn.payment_method || "-"}</td>
                                      <td>
                                        <span
                                          className={`badge ${
                                            txn.payment_status === "Completed"
                                              ? "bg-success"
                                              : txn.payment_status === "Pending"
                                              ? "bg-warning"
                                              : txn.payment_status === "Cancelled"
                                              ? "bg-danger"
                                              : "bg-secondary"
                                          }`}
                                        >
                                          {txn.payment_status || "-"}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>

                              {/* ✅ Pagination UI */}
                              <div className="d-flex justify-content-between align-items-center px-3 py-2">
                                <div>
                                  <label className="me-2">Rows per page:</label>
                                  <select
                                    value={rowsPerPage}
                                    onChange={handleRowsChange}
                                    className="form-select form-select-sm"
                                    style={{
                                      width: "auto",
                                      display: "inline-block",
                                    }}
                                  >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                  </select>
                                </div>
                              
                              <div className="d-flex justify-content-center my-3" style={{
                                float: "right", marginRight: "20px"
                                }}>
                                <ul className="pagination mb-0">
                                  <li
                                    className={`page-item ${
                                      currentPage === 1 ? "disabled" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        handlePageChange(currentPage - 1)
                                      }
                                    >
                                      ‹
                                    </button>
                                  </li>

                                  {getPageNumbers().map((page, index) => (
                                    <li
                                      key={index}
                                      className={`page-item ${
                                        page === currentPage ? "active" : ""
                                      } ${page === "..." ? "disabled" : ""}`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          typeof page === "number" &&
                                          handlePageChange(page)
                                        }
                                      >
                                        {page}
                                      </button>
                                    </li>
                                  ))}

                                  <li
                                    className={`page-item ${
                                      currentPage === totalPages ? "disabled" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        handlePageChange(currentPage + 1)
                                      }
                                    >
                                      ›
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            </>
                          ) : (
                            <>
                            <img
                                src="/images/nodatafoundimg.png" // replace with your image path
                                alt="No documents found"
                                className="img-fluid mb-3 mx-auto d-block mt-3"
                                style={{ maxWidth: "200px" }}
                                />
                            <p className="text-center my-4">
                              No payment history found.
                            </p>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Main Content */}
            </div>
          </div>
        </section>
      </div>

      {/* ✅ Inline Styling for Pagination Look */}
      <style>{`
        .pagination {
          display: flex;
          list-style: none;
          padding-left: 0;
          gap: 6px;
        }
        .page-item {
          display: inline-block;
        }
        .page-link {
          border: 1px solid #ddd;
          color: #333;
          background: #fff;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .page-link:hover {
          background: #f5f5f5;
        }
        .page-item.active .page-link {
          background: #007bff;
          color: #fff;
          border-color: #007bff;
        }
        .page-item.disabled .page-link {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </>
  );
};

export default Mypayment;
